import { render, staticRenderFns } from "./Exbitorshall.vue?vue&type=template&id=2bc03a33&scoped=true&"
import script from "./Exbitorshall.vue?vue&type=script&lang=js&"
export * from "./Exbitorshall.vue?vue&type=script&lang=js&"
import style0 from "./Exbitorshall.vue?vue&type=style&index=0&id=2bc03a33&scoped=true&lang=css&"
import style1 from "./Exbitorshall.vue?vue&type=style&index=1&lang=css&"
import style2 from "./Exbitorshall.vue?vue&type=style&index=2&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc03a33",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardText,VDialog,VIcon,VSelect,VTab,VTabItem,VTabs,VTabsSlider,VTooltip})
